module.exports = __webpack_public_path__ + "static/media/header.342a2ce9.png";